import React from 'react';

import { Checkbox } from 'src/app/components/lib/checkbox';
import { DatePicker } from 'src/app/components/lib/date-picker';
import { DayOfWeekPicker } from 'src/app/components/lib/day-of-week-picker';
import { FormSection } from 'src/app/components/lib/form';
import { Label } from 'src/app/components/lib/label';
import { Radio, RadioGroup } from 'src/app/components/lib/radio';
import { WizardCard } from 'src/app/components/lib/wizard/card';
import { TimePicker } from 'src/app/pages/marketing/discounts/time-picker';

import { isAnyDayOfWeekActive } from '../../shared/helpers';
import { useDiscountWizardStateContext } from '../../state';
import { DetailsStepActions } from '../../state/details';

import { DatePickersWrapper, Disclaimer, FlexColumnWrapper } from './styled';

export function ScheduleCard() {
  const {
    detailsStepState: {
      activeDaysOfTheWeek,
      endDate,
      endTime,
      restrictByDayOfWeek,
      specifyEndDate,
      startDate,
      startTime,
    },
    detailsStepDispatch,
  } = useDiscountWizardStateContext();

  return (
    <WizardCard
      description='Specify the length of your discount by specifying dates, times, and days.'
      title='How long will it run'
    >
      <FormSection>
        <FlexColumnWrapper>
          <DatePickersWrapper>
            <DatePicker
              allowPastDate
              date={startDate}
              enableTime
              inputSx={{ flex: '50% 0 0' }}
              label='Start:'
              labelPlacement='top'
              required
              value={startDate}
              onDateChange={(newStartDate) => {
                detailsStepDispatch({
                  type: DetailsStepActions.SET_START_DATE,
                  payload: newStartDate,
                });
              }}
            />
            <DatePicker
              allowPastDate
              date={endDate}
              disabled={!specifyEndDate}
              disabledPlaceholder='Never'
              enableTime
              hideValueWhenDisabled
              label='End:'
              labelPlacement='top'
              required={specifyEndDate}
              value={endDate}
              onDateChange={(newStartDate) => {
                detailsStepDispatch({
                  type: DetailsStepActions.SET_END_DATE,
                  payload: newStartDate,
                });
              }}
            />
          </DatePickersWrapper>
          <Checkbox
            checked={specifyEndDate}
            label='Specify end date'
            onChange={({ target }) =>
              detailsStepDispatch({ type: DetailsStepActions.SET_SPECIFY_END_DATE, payload: target.checked })
            }
          />
        </FlexColumnWrapper>
        <RadioGroup
          label='Restrict availability by day of week or time of day:'
          labelPlacement='top'
          variant='boolean'
          onChange={({ target }) =>
            detailsStepDispatch({
              type: DetailsStepActions.SET_RESTRICT_BY_DAY_OF_WEEK,
              payload: target.value !== 'false',
            })
          }
        >
          <Radio checked={restrictByDayOfWeek} label='Yes' value />
          <Radio checked={!restrictByDayOfWeek} label='No' value={false} />
        </RadioGroup>
        {restrictByDayOfWeek && (
          <>
            <DayOfWeekPicker
              activeDaysMap={activeDaysOfTheWeek}
              onDayButtonClick={({ day }) =>
                detailsStepDispatch({
                  type: DetailsStepActions.SET_ACTIVE_DAYS_OF_THE_WEEK,
                  payload: { ...activeDaysOfTheWeek, [day]: !activeDaysOfTheWeek[day] },
                })
              }
            />
            <FlexColumnWrapper>
              <DatePickersWrapper>
                <FlexColumnWrapper>
                  <Label>Start time:</Label>
                  <TimePicker
                    disabled={!isAnyDayOfWeekActive(activeDaysOfTheWeek)}
                    setTime={(newTime) =>
                      detailsStepDispatch({ type: DetailsStepActions.SET_START_TIME, payload: newTime })
                    }
                    time={startTime}
                  />
                </FlexColumnWrapper>
                <FlexColumnWrapper>
                  <Label>End time:</Label>
                  <TimePicker
                    disabled={!isAnyDayOfWeekActive(activeDaysOfTheWeek)}
                    setTime={(newTime) =>
                      detailsStepDispatch({ type: DetailsStepActions.SET_END_TIME, payload: newTime })
                    }
                    time={endTime}
                  />
                </FlexColumnWrapper>
              </DatePickersWrapper>
              <Disclaimer>
                Start and end time are linked to day selection. At least one day of the week must be selected to use
                these settings. If no selections are made the discount will run all day.
              </Disclaimer>
            </FlexColumnWrapper>
          </>
        )}
      </FormSection>
    </WizardCard>
  );
}
